import { render, staticRenderFns } from "./home-how-it-works-v2.vue?vue&type=template&id=2f3d8792&scoped=true&"
import script from "./home-how-it-works-v2.vue?vue&type=script&lang=js&"
export * from "./home-how-it-works-v2.vue?vue&type=script&lang=js&"
import style0 from "./home-how-it-works-v2.vue?vue&type=style&index=0&id=2f3d8792&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d8792",
  null
  
)

export default component.exports